/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/no-unused-expressions */

export function applyPendoSnippet(apiKey: string) {
  // START Pendo provided Snippet
  (function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    // @ts-expect-error vendor snippet, left as provided
    o._q = o._q || [];
    v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
    for (w = 0, x = v.length; w < x; ++w) {
      (function (m) {
        // @ts-expect-error vendor snippet, left as provided
        o[m] =
          // @ts-expect-error vendor snippet, left as provided
          o[m] ||
          function () {
            // @ts-expect-error vendor snippet, left as provided
            o._q[m === v[0] ? "unshift" : "push"]([m].concat([].slice.call(arguments, 0)));
          };
      })(v[w]);
    }
    y = e.createElement(n);
    y.async = !0;
    y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, "script", "pendo");
  // END Pendo provided Snippet
}
